import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import cx from 'clsx';

export type Props = {
  size?: 'small' | 'medium';
  title: string;
  count: number;
  severity?: 'error' | 'info' | 'warning';
  renderCount?: () => React.ReactElement;
  className?: string;
};

const StatItem = ({
  size,
  title,
  count,
  severity,
  renderCount,
  className
}: Props): React.ReactElement => {
  const classes = useStyles();

  return (
    <Grid className={cx(classes.root, { [classes.rootSmall]: size === 'small' }, className)}>
      <Typography component="h3" variant="body2" noWrap>
        {title}
      </Typography>
      {renderCount ? (
        renderCount()
      ) : (
        <Typography
          component="span"
          variant="h3"
          className={cx(classes.statText, severity && classes[severity])}
        >
          {count}
        </Typography>
      )}
    </Grid>
  );
};

const useStyles = makeStyles(theme => ({
  error: {
    color: theme.palette.error.main
  },
  info: {
    color: theme.palette.info.main
  },
  warning: {
    color: theme.palette.warning.main
  },
  root: {
    border: `1px solid #C3C3C3`,
    borderRadius: 4,
    padding: theme.spacing(1),
    paddingBottom: theme.spacing(0.5),
    paddingTop: theme.spacing(0.5),
    margin: theme.spacing(0.5),
    minWidth: 120
  },
  rootSmall: {
    minWidth: 80
  },
  statText: {}
}));

export default StatItem;
